import { service } from '@ember/service'
import ExtensionLogger from '@peekops/peek-extensions-framework/ExtensionLogger'
import ExtensionStyles from '@peekops/peek-extensions-framework/ExtensionStyles'
import { action } from '@ember/object'
import PeekExtensionsAPIService from '@peekops/peek-extensions-framework/services/extensions/extensions-api'

/**
 * methods from this service needs to be declared as @action so context its bound correctly
 * OR use .bind(this) when referencing local methods
 * other services functions should also be bound, so those functions can target respective services correctly
 * as "this" = this service
 */
export default class CustomerFlowsPeekExtensionsAPIService extends PeekExtensionsAPIService {
  @service flowManager: FlowManager

  // to avoid giving access to the service instance, we provide a proxy with only the methods we want to expose
  // to extensions code. NOTE: Be sure to use .bind(this/externalService) to correctly bind context
  @action
  getAPIProxy(logsEnabled = false) {
    if (!ExtensionLogger.enabled && logsEnabled) {
      ExtensionLogger.enabled = logsEnabled
    }

    return {
      methods: {
        invokeLookup: this.invokeLookup.bind(this),
        // modifyStep: (extension: Extension) => new StepModifier(extension, this.flowManager),
        updateFlow: () => this.flowManager.evaluateSteps()
      },
      styles: {
        customProperties: ExtensionStyles.availableCSSCustomProperties,
        setCSSCustomProperty: ExtensionStyles.setCSSCustomProperty.bind(ExtensionStyles)
      },
      logger: {
        log: this.log.bind(this),
        logError: this.logError.bind(this)
      },
      apolloGql: {},
      constants: {}
    }
  }
}
